var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 1.9976C11.511 1.8225 11.7189 1.68361 11.9477 1.58885C12.1765 1.49409 12.4216 1.44531 12.6693 1.44531C12.9169 1.44531 13.1621 1.49409 13.3909 1.58885C13.6196 1.68361 13.8275 1.8225 14.0026 1.9976C14.1777 2.17269 14.3166 2.38056 14.4114 2.60934C14.5061 2.83811 14.5549 3.08331 14.5549 3.33093C14.5549 3.57855 14.5061 3.82375 14.4114 4.05253C14.3166 4.2813 14.1777 4.48917 14.0026 4.66426L5.0026 13.6643L1.33594 14.6643L2.33594 10.9976L11.3359 1.9976Z",
    stroke: "#5A4AD5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.c96cead4093e3ed81d8cff82cf579629.svg";
export { ForwardRef as ReactComponent };